
















































import Vue from 'vue'
import moment from 'moment'
import { TranslateResult } from 'vue-i18n'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { ABSENCES_ASSISTANT_SET_PERIODICITY } from '@/store/action-types'
import {
  ABSENCES_ASSISTANT_GET_END_DATE, ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE,
  ABSENCES_ASSISTANT_GET_START_DATE,
  GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import { AbsenceSerie } from '@/types/service-response'
import { Absence } from '@/model/absences/Absence'

interface ComponentData {
  isUnique: boolean,
  weekDayList: Array<DayListItem>
  selectedWeekDayList: Array<number>

  repeatEveryNthWeek: number
  expireAfterRepetitions: number
  expireAfterDateIso: string | undefined
}

interface DayListItem {
  number: number
  day: TranslateResult
}

export default Vue.extend({
  name: 'AbsencesEditorPeriodicity',

  props: {
    editAbsence: Object as () => Absence | undefined,
    editAbsenceSerie: Object as () => AbsenceSerie | undefined,
  },

  data (): ComponentData {
    return {
      isUnique: true,

      weekDayList: [
        {
          day: this.$t('absencesPage.monday'),
          number: 1
        },
        {
          day: this.$t('absencesPage.tuesday'),
          number: 2
        },
        {
          day: this.$t('absencesPage.wednesday'),
          number: 3
        },
        {
          day: this.$t('absencesPage.thursday'),
          number: 4
        },
        {
          day: this.$t('absencesPage.friday'),
          number: 5
        },
        {
          day: this.$t('absencesPage.saturday'),
          number: 6
        },
        {
          day: this.$t('absencesPage.sunday'),
          number: 7
        },
      ],

      selectedWeekDayList: [],

      repeatEveryNthWeek: 1,
      expireAfterRepetitions: 0,
      expireAfterDateIso: undefined
    }
  },

  computed: {
    expireAfterDateFormatted: {
      get (): string | undefined {
        if (this.expireAfterDateIso) {
          return moment(this.expireAfterDateIso).format('DD.MM.YYYY')
        }

        return undefined
      },

      // setter is only for clear action to work
      set (): void {
        this.expireAfterDateIso = undefined

        this.updateStoreValues()
      }
    },

    isEnabled (): boolean {
      return this.isUnique
    },

    isEdittingAbsence (): boolean {
      return !!this.editAbsence
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE]
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isPeriodicityDisabled (): boolean {
      const dateStart: Date = this.$store.getters[ABSENCES_ASSISTANT_GET_START_DATE]
      const dateEnd: Date = this.$store.getters[ABSENCES_ASSISTANT_GET_END_DATE]

      if(moment(dateStart).format('DD:MM:YYYY') === moment(dateEnd).format('DD:MM:YYYY')) {
        return false
      } else {
        this.resetState()
        return true
      }

    }
  },

  watch: {
    isUnique (newVal: boolean): void {
      if (newVal) {
        this.resetState()
      }

      this.updateStoreValues()
    }
  },

  methods: {
    onFieldValueChange (): void {
      this.updateStoreValues()
    },

    updateStoreValues (): void {
      const payload: PlanningAssistantPeriodicityPayload = {
        isUnique: this.isUnique,
        weekDayList: this.selectedWeekDayList,
        repeatEveryNthWeek: this.repeatEveryNthWeek,
        expireAfterRepetitions: this.expireAfterRepetitions,
        expireAfterDate: this.expireAfterDateIso && moment(this.expireAfterDateIso).toDate() || undefined
      }

      this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY, payload)
    },

    resetState (): void {
      if(this.editAbsenceSerie) {
        let days: Array<number> = []
        if(this.editAbsenceSerie.Montag === 1){
          days.push(1)
        }
        if(this.editAbsenceSerie.Dienstag === 1){
          days.push(2)
        }
        if(this.editAbsenceSerie.Mittwoch === 1){
          days.push(3)
        }
        if(this.editAbsenceSerie.Donnerstag === 1){
          days.push(4)
        }
        if(this.editAbsenceSerie.Freitag === 1){
          days.push(5)
        }
        if(this.editAbsenceSerie.Samstag === 1){
          days.push(6)
        }
        if(this.editAbsenceSerie.Sonntag === 1){
          days.push(7)
        }

        this.isUnique = this.editAbsenceSerie.Einmalig !== 0
        this.selectedWeekDayList = days
        this.repeatEveryNthWeek = this.editAbsenceSerie.Whlg
        this.expireAfterRepetitions = this.editAbsenceSerie.EndAfternTimes
        this.expireAfterDateIso = this.editAbsenceSerie.EndAfterDate!
      } else {
        this.isUnique = true
        this.selectedWeekDayList = []
        this.repeatEveryNthWeek = 1
        this.expireAfterRepetitions = 0
        this.expireAfterDateIso = undefined
      }
    }
  },

  mounted (): void {
    this.resetState()
  }
})
